module.exports = __webpack_public_path__ + "static/img/mh.9be240d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/mh.png
// module id = kz0f
// module chunks = 18